// components/templates/sections/NAVBAR_COFFEE.tsx
"use client";
import { useState, useEffect } from "react";
import { useDesign } from "@/context/DesignContext";

type NavbarProps = {
  brand?: string;
  logoUrl?: string;
  links?: string[] | string;
  ctaText?: string;
  design?: any;
};

export default function NAVBAR_COFFEE({ brand = "Vertrin", logoUrl, links = [], ctaText = "Order Now", design: propDesign }: NavbarProps) {  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const [scrolled, setScrolled] = useState(false);
  const linksArray = Array.isArray(links) ? links : [];

  // Get design values with fallbacks
  const primaryColor = design?.colors?.primary || "#C8622A";
  const bgDark = design?.colors?.background || "#0C0500";
  const linkColor = design?.colors?.textLight || "#BFA76A";
  const linkHoverColor = design?.colors?.secondary || "#E8A45A";
  const buttonBorderColor = primaryColor;
  const buttonTextColor = linkHoverColor;
  const buttonHoverBg = primaryColor;
  const buttonHoverText = bgDark;

  console.log('🔍 NAVBAR_COFFEE props:', { brand, logoUrl, links, ctaText });
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navbarBg = scrolled ? `rgba(12,5,0,0.88)` : "transparent";
  const borderClass = scrolled ? `border-b border-${primaryColor}/20` : "";

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "py-3 backdrop-blur-xl" : "py-6"}`}
         style={{ background: navbarBg, borderBottom: scrolled ? `1px solid ${primaryColor}33` : "none" }}>
      <div className="max-w-7xl mx-auto px-8 flex items-center justify-between">
        <div className="flex items-center gap-3">
        {logoUrl ? (
          <img src={logoUrl} alt={brand} className="h-8 w-auto" />
        ) : (
          <div className="relative w-8 h-8">
            <div className="absolute inset-0 rounded-full pulse-ring" style={{ backgroundColor: primaryColor }} />
            <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: primaryColor }}>
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: design?.colors?.text || "#F5E6D3" }} />
            </div>
          </div>
        )}
        <span className="font-display text-xl font-bold tracking-widest uppercase" style={{ letterSpacing: "0.3em", color: design?.colors?.text || "#F5E6D3" }}>
          {brand}
        </span>
      </div>
        <ul className="hidden md:flex items-center gap-10">
          {linksArray.map((link) => (
            <li key={link}>
              <a href={`#${link.toLowerCase()}`}
                 className="font-mono-custom text-xs tracking-widest uppercase transition-colors duration-300"
                 style={{ color: linkColor }}
                 onMouseEnter={(e) => e.currentTarget.style.color = linkHoverColor}
                 onMouseLeave={(e) => e.currentTarget.style.color = linkColor}>
                {link}
              </a>
            </li>
          ))}
        </ul>
        <button className="font-mono-custom text-xs tracking-widest uppercase px-6 py-2.5 transition-all duration-300"
                style={{
                  border: `1px solid ${buttonBorderColor}99`,
                  color: buttonTextColor,
                  background: "transparent",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = buttonHoverBg;
                  e.currentTarget.style.color = buttonHoverText;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = buttonTextColor;
                }}>
          {ctaText}
        </button>
      </div>
    </nav>
  );
}